import { useEffect, useRef, useState } from 'react';
import { getSoundSettings, onSoundSettings, play, setSoundSettings } from '../audio/sound';

/** Speaker button in the top bar: music and sound effects on/off, with volumes. */
export function SoundMenu() {
  const [s, setS] = useState(getSoundSettings);
  const [open, setOpen] = useState(false);
  const box = useRef<HTMLDivElement>(null);
  useEffect(() => onSoundSettings(setS), []);
  useEffect(() => {
    if (!open) return;
    const close = (e: PointerEvent) => !box.current?.contains(e.target as Node) && setOpen(false);
    const esc = (e: KeyboardEvent) => e.key === 'Escape' && setOpen(false);
    window.addEventListener('pointerdown', close);
    window.addEventListener('keydown', esc);
    return () => {
      window.removeEventListener('pointerdown', close);
      window.removeEventListener('keydown', esc);
    };
  }, [open]);
  const muted = !s.music && !s.sfx;
  return (
    <div className="sound-menu" ref={box}>
      <button className="btn ghost icon-btn" onClick={() => setOpen((o) => !o)} aria-expanded={open} aria-label="Sound settings" title="Sound">
        {muted ? '🔇' : '🔊'}
      </button>
      {open && (
        <div className="sound-pop" role="group" aria-label="Sound settings">
          <label className="check-row">
            <input type="checkbox" checked={s.music} onChange={(e) => setSoundSettings({ music: e.currentTarget.checked })} />
            <span>Music</span>
          </label>
          <input type="range" min={0} max={1} step={0.05} value={s.musicVolume} disabled={!s.music} aria-label="Music volume" onChange={(e) => setSoundSettings({ musicVolume: Number(e.currentTarget.value) })} />
          <label className="check-row">
            <input type="checkbox" checked={s.sfx} onChange={(e) => setSoundSettings({ sfx: e.currentTarget.checked })} />
            <span>Sound effects</span>
          </label>
          <input
            type="range"
            min={0}
            max={1}
            step={0.05}
            value={s.sfxVolume}
            disabled={!s.sfx}
            aria-label="Sound effects volume"
            onChange={(e) => setSoundSettings({ sfxVolume: Number(e.currentTarget.value) })}
            onPointerUp={() => play('coin')}
          />
          <button className="btn small ghost" onClick={() => setSoundSettings(muted ? { music: true, sfx: true } : { music: false, sfx: false })}>{muted ? 'Turn all sound on' : 'Mute everything'}</button>
        </div>
      )}
    </div>
  );
}
